import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import logo from "../../../assets/AM_GAM_CARGO_VERTICAL_RGB.png";
import { loginLiftTruck } from "../services/liftApi";
import { saveLiftSession } from "../services/liftSession";
import "./login.css";

// Réplica del flujo de amcmontacargas-L8.8 (PWAController::postLogin): dos
// campos, employee_number + pin, y el backend resuelve las 3 salidas
// posibles (login OK / no existe el montacarguista / pin incorrecto).
function MontacargasLogin() {
  const navigate = useNavigate();
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [pin, setPin] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSubmitting(true);

    try {
      const response = await loginLiftTruck({ employee_number: employeeNumber, pin });
      saveLiftSession(response.data);
      navigate("/montacargas/home");
    } catch (error) {
      const backendMessage = error.response?.data?.message;
      setErrorMessage(backendMessage || "No se pudo iniciar sesión, intenta de nuevo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="montacargas-login">
      <div className="montacargas-login-card mx-auto">
        <div className="text-center mb-4">
          <img src={logo} alt="Aeroméxico Cargo" className="montacargas-login-logo" />
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <p className="montacargas-login-hint text-center">
            Introduce tu usuario y contraseña
          </p>

          <div className="mb-3">
            <label className="form-label small" htmlFor="montacargas-employee-number">
              Número de empleado
            </label>
            <input
              id="montacargas-employee-number"
              type="text"
              className="form-control"
              value={employeeNumber}
              onChange={(event) => setEmployeeNumber(event.target.value)}
              autoComplete="username"
              disabled={submitting}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label small" htmlFor="montacargas-pin">
              Pin del día
            </label>
            <input
              id="montacargas-pin"
              type="text"
              inputMode="numeric"
              className="form-control"
              value={pin}
              onChange={(event) => setPin(event.target.value)}
              autoComplete="off"
              disabled={submitting}
              required
            />
          </div>

          {errorMessage && (
            <div className="alert alert-danger py-2 text-center mb-3" role="alert">
              {errorMessage}
            </div>
          )}

          <div className="d-flex justify-content-center">
            <button type="submit" className="primary-btn" disabled={submitting}>
              {submitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Ingresando...
                </>
              ) : (
                "Iniciar sesión"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MontacargasLogin;
